module.exports = __webpack_public_path__ + "aed1289d34c94568609517563fd4a42f.MP3";